import styled from 'styled-components';
import { Empty as EmptyAtom } from 'components/atoms/empty';
import { Text03, HelperText01 } from 'components/styles';

export const Empty = styled(EmptyAtom)`
  justify-content: center;
`;

export const AttachmentsEmpty = styled(Empty)`
  flex-direction: column;
  background: var(--cool-gray-10);
`;

export const Description = styled.div`
  ${HelperText01};
  ${Text03};
`;

interface NodeWrapperProps {
  readonly?: boolean;
}
export const NodeWrapper = styled.div<NodeWrapperProps>`
  [data-test-id='remove-attachment-button-grid'] {
    display: ${(p) => (p.readonly ? 'none' : 'flex')};
  }
  [data-test-id='remove-attachment-button-table'] {
    display: ${(p) => (p.readonly ? 'none' : 'inline-flex')};
  }
`;
